import React, { useState, useEffect, FunctionComponent } from 'react';
import { Environment, graphql, createFragmentContainer } from 'react-relay';

import { PdpRespConsumerSourcingModalLoader_item } from './__generated__/PdpRespConsumerSourcingModalLoader_item.graphql';

import {
    shouldSeeConsumerSourcingModal,
    shouldSuppressMessage,
} from '../PdpSharedConsumerSourcingModal/helpers/pdpSharedConsumerSourcingModalDisplayHelpers';

type ComponentProps = {
    item: PdpRespConsumerSourcingModalLoader_item;
    userId: string;
    environment: Environment;
};

const PdpRespConsumerSourcingModal = React.lazy(() =>
    import(/* webpackChunkName: "PdpRespConsumerSourcingModal" */ './PdpRespConsumerSourcingModal')
);

export const PdpRespConsumerSourcingModalLoaderComponent: FunctionComponent<ComponentProps> = ({
    item,
    userId,
    environment,
}) => {
    const [isOpen, setIsOpen] = useState(false);
    const itemId = item?.serviceId;
    useEffect(() => {
        const modifyModalOpenState = async (): Promise<void> => {
            if (itemId && !shouldSuppressMessage({ userId })) {
                const res = await shouldSeeConsumerSourcingModal({ itemId, userId, environment });
                setIsOpen(res);
            }
        };
        modifyModalOpenState();
    }, [environment, itemId, userId]);

    return isOpen ? (
        <React.Suspense fallback={''}>
            <PdpRespConsumerSourcingModal
                isOpen={isOpen}
                onClose={() => setIsOpen(false)}
                userId={userId}
                item={item}
            />
        </React.Suspense>
    ) : null;
};

export const PdpRespConsumerSourcingModalLoader = createFragmentContainer(
    PdpRespConsumerSourcingModalLoaderComponent,
    {
        item: graphql`
            fragment PdpRespConsumerSourcingModalLoader_item on Item {
                serviceId
                ...PdpRespConsumerSourcingModal_item
            }
        `,
    }
);
